export enum SoundMove {
  All,
  OnlyOwn,
  None,
}
